// extracted by mini-css-extract-plugin
export default {"ModuleError":"ModuleError_ModuleError__kapWI"};